import React from "react";
import SalesManagerDashboard from "../../components/sales-manager/SalesManagerDashboard";

const SalesManagerPage: React.FC = () => {
  return <SalesManagerDashboard />;
};

export default SalesManagerPage;